import React, { useEffect, useState } from "react";

const fireicon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/fire.svg";
const badgeIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/badges/1.svg";
const userIconDefault =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profilevectro.svg";

export default function BadgePopup({
  isVisible,
  onClose,
  text,
  badgeimage,
  score,
  userIcon,
}) {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
    } else {
      const timer = setTimeout(() => setShouldRender(false), 800);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  if (!shouldRender) return null;
  return (
    <div
      className={`popup-overlay ${isVisible ? "fadeIn" : "fadeOut"}`}
      onClick={onClose}
    >
      <div
        className={`badge-popup ${isVisible ? "popup-open" : "popup-close"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="frontbadge">
          <div className="badgetopfront">
            <h2>Badge Unlocked</h2>
            <div className="headerstreaksbadge">
              <img src={fireicon} alt="Fire" />
              <p>{score}</p>
            </div>
          </div>
          <div className="badgebody">
            <div className="badgeimage">
              <img
                src={userIcon === undefined ? userIconDefault : userIcon}
                alt="User"
              />
              <div className="badgeimagemain">
                <img src={badgeimage} alt="badge" />
              </div>
            </div>
            <div className="badgebodycontent">
              <h2>Achievement Description</h2>
              {text ? (
                <p>{text}</p>
              ) : (
                <p>Great Work! You have unlocked a new Badge.</p>
              )}

              <div className="achievementlinebottombadge"></div>
            </div>
          </div>
        </div>
        <div className="backbadge"></div>
      </div>
    </div>
  );
}
